import React from "react";
import { connect } from "react-redux";
import { IdleTimerProvider } from "react-idle-timer"; // import IdleTimer from "react-idle-timer";
import Countly from "countly-sdk-web";

import { findBaseURL, isNetworkRequestFailedError } from "./config/helpers";
import activationOptionModalAction from "../src/redux/activationOptionModal/action";
import ActivationOptionModal from "../src/component/ActivationOptionModal";
import { checkPermissionForNonMember } from "./config/helpers";
import constants from "./config/constants";
import api from "./config/api";
import referralAction from "./redux/referral/action";
import authAction from "./redux/auth/action";
import historyAction from "./redux/history/action";
import AlertBox from "./component/AlertBox/AlertBox";
import Sidebar from "./component/Sidebar/Sidebar";
import Header from "./component/Header/Header";
import BackgroundIcon from "./component/BackgroundIcon/BackgroundIcon";
import CustomLoader from "./component/CustomLoader/CustomLoader";
import Router from "./config/Router";
import InfoBanner from "./component/InfoBanner";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    // this.onIdle = this._onIdle.bind(this);
  }

  componentDidMount = async () => {
    // let isAccepted = await sessionStorage.getItem("IsConsentAccepted")

    // try {
    //   if (isAccepted === "false") {
    //     await removeUser()
    //     sessionStorage.removeItem("user")
    //     sessionStorage.removeItem("IsConsentAccepted")
    //   }
    // } catch (error) {
    //   return null
    // }

    this.checkLogin(this.props);
    this.fetchAllBanks();
    this.fetchAllRelationships();
    this.checkPermission(this.props.user);

    if (!this.props.allEmployers.length) this.getAllEmployers();
  };

  // async _onIdle(e) {
  //   const {
  //     user,
  //     showLoader,
  //     removeUser,
  //     hideLoader,
  //     localHistory,
  //     setHistory,
  //     openSidebar,
  //     closeSidebar
  //   } = this.props;

  //   if (user) {
  //     try {
  //       showLoader();
  //       await api.logout(null, user.token);
  //     } catch (e) {}

  //     sessionStorage.removeItem("user");
  //     removeUser();
  //     localHistory.push("/login");
  //     setHistory(localHistory);
  //     openSidebar();
  //     closeSidebar();

  //     hideLoader();
  //   }
  // }

  checkPermission = (user) => {
    const route = window.location.pathname;

    if (user) {
      const isMember = user.allRoles.some(
        (item) => item.id === constants.MEMBER_CODE
      );

      if (!isMember) {
        const shouldNavigate = checkPermissionForNonMember(route);
        if (!shouldNavigate) window.location.replace("/");
      }
    }
  };

  fetchAllRelationships = async () => {
    const { setRelationShips, setAlertMessage } = this.props;

    try {
      const response = await api.getRelationships();
      setRelationShips(response.data.result);
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.fetchAllRelationships
          : null,
      });
    }
  };

  fetchAllBanks = async () => {
    const { setAllBanks, setAlertMessage } = this.props;

    try {
      const response = await api.getAllBanks();
      setAllBanks(response.data.result);
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchAllBanks : null,
      });
    }
  };

  getAllEmployers = async () => {
    const { setAllEmployers } = this.props;

    try {
      const response = await api.getAllEmployers();

      setAllEmployers(response.data.result);
      sessionStorage.setItem(
        "allEmployers",
        JSON.stringify(response.data.result)
      );
    } catch (e) {
      console.log("e =>", e);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { localHistory: prevHistory } = this.props;
    const { localHistory: nextHistory } = nextProps;

    if (JSON.stringify(prevHistory) !== JSON.stringify(nextHistory)) {
      this.checkLogin(nextProps);
    }
  }

  checkLogin = (props) => {
    const { localHistory, user } = props;
    const pathname = localHistory && localHistory.location.pathname;

    let isAuthScreen = true;

    const isAlwaysAllowed = constants.ALWAYS_ALLOWED_ROUTES.some(
      (item) => pathname === item
    );

    if (isAlwaysAllowed) {
      return;
    }

    constants.NON_PROTECTED_ROUTES.forEach((item) => {
      if (pathname === item) {
        isAuthScreen = false;
      }
    });

    if (localHistory) {
      if (user) {
        const isAccepted = sessionStorage.getItem("IsConsentAccepted");

        if (
          isAuthScreen &&
          pathname !== "/consentscreen" &&
          isAccepted === "false"
        ) {
          localHistory.replace("/consentscreen");
        }

        //eslint-disable-next-line
        if (!isAuthScreen && pathname != "/consentscreen")
          localHistory.replace("/");
        // this.resetIdle();
      } else {
        if (pathname === "/onboarding") {
          localHistory.replace("/login?redirect=onboarding");
        } else if (pathname === "/rsapin") {
          localHistory.replace("/login?redirect=rsapin");
        } else if (isAuthScreen) {
          localHistory.replace("/login");
        }
      }
    }
  };

  // resetIdle = () => {
  //   this.idle.reset();
  // };

  determineIfAuthScreens = () => {
    const { localHistory } = this.props;

    const pathname = localHistory && localHistory.location.pathname;
    let isAuthScreen = true;

    constants.NON_PROTECTED_ROUTES.forEach((item) => {
      if (pathname === item) {
        isAuthScreen = false;
      }
    });

    return isAuthScreen;
  };

  shouldCoverFullScreen = () => {
    const { localHistory } = this.props;

    const pathname = localHistory && localHistory.location.pathname;
    let isFullScreen = false;

    constants.FULL_SCREEN_ROUTES.forEach((item) => {
      if (pathname === item) {
        isFullScreen = true;
      }
    });

    return isFullScreen;
  };

  handleCloseMenu = (e) => {
    const name = e.target.getAttribute("data-name");

    if (name !== "drop-down-menu-item") {
      this.header.setMenu(false);
    }
  };

  onIdle = () => {
    if (this.props.user) {
      this.logoutUser();
    }
  };

  navigate = (route) => {
    const { localHistory, setHistory, openSidebar, closeSidebar } = this.props;

    localHistory.push(route);
    setHistory(localHistory);
    openSidebar();
    closeSidebar();
  };

  logoutUser = async () => {
    const { user, removeUser } = this.props;
    try {
      await api.logout(null, user.token);
      sessionStorage.removeItem("user");
      Countly.q.push([
        "logout",
        {
          key: "click",
          count: 1,
        },
      ]);

      this.navigate("/login");
      removeUser();
      const newURL = findBaseURL(window.location.href);
      window.location.replace(newURL);
    } catch (e) {
      sessionStorage.removeItem("user");
      this.navigate("/login");
      removeUser();
    }
  };

  render() {
    const { alertMessage, isLoading } = this.props;

    return (
      <IdleTimerProvider timeout={1000 * 60 * 5} onIdle={this.onIdle}>
        <div onClick={this.handleCloseMenu}>
          <div className="main-container d-flex justify-content-center align-items-center">
            <BackgroundIcon />
            <div
              className={`card-container ${
                window.location.pathname === "/consentscreen" &&
                "consent-card-container"
              } ${alertMessage && "blur-container"} ${
                this.shouldCoverFullScreen() && "w-100 h-100"
              }`}
            >
              {this.determineIfAuthScreens() && <Sidebar />}
              <div
                className="flex1 d-flex flex-column"
                style={{ overflow: "auto", position: "relative" }}
              >
                {this.determineIfAuthScreens() && (
                  <Header customRef={(el) => (this.header = el)} />
                )}
                <Router />
              </div>
            </div>
          </div>
          {alertMessage && (
            <AlertBox
              type={alertMessage.type}
              secondMessage={alertMessage.secondMessage}
              message={alertMessage.message}
              onTryAgain={alertMessage.onTryAgain}
            />
          )}
          {isLoading && <CustomLoader />}
          {/* <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={60000}
        /> */}
          {this.props.activationOptionModal?.visible && (
            <ActivationOptionModal
              visible={this.props.activationOptionModal?.visible}
              data={this.props.activationOptionModal.data}
              onOptionSelected={(selectedOption) => {
                this.props.removeActivationModal();
                const pathname = this.props.localHistory.location.pathname;
                console.log("pathname =>", pathname);

                if (selectedOption === "link" && pathname === "/register") {
                  this.props.localHistory.push("/login");
                }

                if (selectedOption === "otp") {
                  this.props.localHistory.push("/useractivation");
                }
              }}
            />
          )}
          <InfoBanner />
        </div>
      </IdleTimerProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  localHistory: state.history.localHistory,
  alertMessage: state.auth.alertMessage,
  isLoading: state.auth.isLoading,
  allEmployers: state.auth.allEmployers,
  user: state.auth.user,
  activationOptionModal: state.activationOptionModal,
});

const mapDispatchToProps = {
  setAllBanks: referralAction.setAllBanks,
  setAlertMessage: authAction.setAlertMessage,
  setAllEmployers: authAction.setAllEmployers,
  setRelationShips: authAction.setRelationShips,
  showLoader: authAction.showLoader,
  hideLoader: authAction.hideLoader,
  openSidebar: authAction.openSidebar,
  closeSidebar: authAction.closeSidebar,
  setHistory: historyAction.setHistory,
  removeActivationModal: activationOptionModalAction.removeActivationModal,
  removeUser: authAction.removeUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
